//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import angular from 'angular';
import _ from 'underscore';

import template from './showroom-settings-email-capture.html';

import { debounce } from '@utils/debounce';

class ShowroomSettingsEmailCapture {
  public emailCaptureState;
  public callToActionChanged: boolean;
  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;
  public onCallToActionChanged = debounce(() => {
    if (!this.callToActionChanged) {
            // Since the CTA field is updated live, we will only log a GA event once
            // per "session" where a session is defined by:
            // 1) a fresh load of the Add Ons panel or
            // 2) a toggle of the email capture module
      this.callToActionChanged = true;
      this.TrackingService.recordEvent(
                this.trackingCategory,
                this.trackingAction,
                this.trackingLabels.ctaChanged,
            );
    }
    this.ShowroomService.updateEmailCaptureState(this.sanitizedEmailCaptureState());
  }, 200);

  constructor(
        private UniversalImageActionsService,
        private ShowroomService,
        private TrackingService,
    ) { }

  public onEmailCaptureToggled = () => {
    this.emailCaptureState.isEnabled = !this.emailCaptureState.isEnabled;
    this.ShowroomService.updateEmailCaptureState(this.sanitizedEmailCaptureState());

    this.callToActionChanged = false;

    this.TrackingService.recordEvent(
            this.trackingCategory,
            this.trackingAction,
            this.trackingLabels.toggleEmailCapture(this.emailCaptureState.isEnabled),
        );
  }

  public $onInit() {
    const launchOptions = this.UniversalImageActionsService.getCurrentLaunchOptions();
    const universalItemId = launchOptions.getUniversalItemId();

    this.callToActionChanged = false;

    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      toggleEmailCapture: (enabled) => (enabled) ? 'EmailCaptureEnabled' : 'EmailCaptureDisabled',
      ctaChanged: 'CallToActionUpdated',
      emailCaptureExportClicked: 'EmailCaptureMetrics',
      helpLinkClicked: (linkName) => `HelpLinkClicked=${linkName}`,
    };

    this.ShowroomService.getCurrentConfigStatusObservable().subscribe((currentState) => {
      const state = angular.copy(currentState);
      this.emailCaptureState = _(this.emailCaptureState || {}).extend(state.emailCaptureState);
    });
    this.ShowroomService.loadExistingState(universalItemId);
  }

  private sanitizedEmailCaptureState = () => {
    const safeCaptureState = angular.copy(this.emailCaptureState);
        // If email capture is disabled, clear the callToAction field
    if (!safeCaptureState.isEnabled) {
      delete safeCaptureState.callToAction;
    }
    return safeCaptureState;
  }
}

angular.module('uia').component('showroomSettingsEmailCapture', {
  template,
  controller: [
    'UniversalImageActionsService',
    'ShowroomService',
    'TrackingService',
    ShowroomSettingsEmailCapture,
  ],
});
